import { createSlice } from '@reduxjs/toolkit';

import {
  getExchanges,
  getExchangesEdit,
  getExchangesGivenMerchant,
  getExchangesReceivedMerchant,
  getExchangesParsers,
  getGivenExchangesLabels,
  getReceivedExchangesLabels,
  getStatuses,
  getWeGoldExchanges,
} from './exchanges.actions';

const initialState = {
  exchanges: [],
  receiveExchanges: [],
  isLoadingExchanges: [],

  exchange: {},
  isLoadingExchange: false,

  merchants: [],
  receivedMerchants: [],
  isLoadingMerchants: false,

  parsers: [],
  isLoadingParsers: false,

  statuses: [],
  isLoadingStatuses: false,

  givenFilters: [],
  isLoadingGivenFilters: false,

  receivedFilters: [],
  isLoadingReceivedFilters: false,
};

const exchangesSlice = createSlice({
  name: 'exchanges',
  initialState,
  reducers: {
    setReceiveExchanges: (state, action) => {
      state.receiveExchanges = action.payload;
    },

    clearExchangesState: (state) => {
      state = initialState;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getExchanges.pending, (state) => {
      state.isLoadingExchanges = true;
    });
    builder.addCase(getExchanges.fulfilled, (state, action) => {
      state.exchanges = action.payload;
      state.isLoadingExchanges = false;
    });
    builder.addCase(getExchanges.rejected, (state) => {
      state.isLoadingExchanges = false;
    });

    builder.addCase(getWeGoldExchanges.pending, (state) => {
      state.isLoadingExchanges = true;
    });
    builder.addCase(getWeGoldExchanges.fulfilled, (state, action) => {
      state.exchanges = action.payload;
      state.isLoadingExchanges = false;
    });
    builder.addCase(getWeGoldExchanges.rejected, (state) => {
      state.isLoadingExchanges = false;
    });

    builder.addCase(getExchangesEdit.pending, (state) => {
      state.isLoadingExchange = true;
    });
    builder.addCase(getExchangesEdit.fulfilled, (state, action) => {
      state.exchange = action.payload;
      state.isLoadingExchange = false;
    });
    builder.addCase(getExchangesEdit.rejected, (state) => {
      state.isLoadingExchange = false;
    });

    builder.addCase(getExchangesGivenMerchant.pending, (state) => {
      state.isLoadingMerchants = true;
    });
    builder.addCase(getExchangesGivenMerchant.fulfilled, (state, action) => {
      state.merchants = action.payload;
      state.isLoadingMerchants = false;
    });
    builder.addCase(getExchangesGivenMerchant.rejected, (state) => {
      state.isLoadingMerchants = false;
    });

    builder.addCase(getExchangesReceivedMerchant.pending, (state) => {
      state.isLoadingMerchants = true;
    });
    builder.addCase(getExchangesReceivedMerchant.fulfilled, (state, action) => {
      state.receivedMerchants = action.payload;
      state.isLoadingMerchants = false;
    });
    builder.addCase(getExchangesReceivedMerchant.rejected, (state) => {
      state.isLoadingMerchants = false;
    });

    builder.addCase(getExchangesParsers.pending, (state) => {
      state.isLoadingParsers = true;
    });
    builder.addCase(getExchangesParsers.fulfilled, (state, action) => {
      state.parsers = action.payload;
      state.isLoadingParsers = false;
    });
    builder.addCase(getExchangesParsers.rejected, (state) => {
      state.isLoadingParsers = false;
    });

    builder.addCase(getStatuses.pending, (state) => {
      state.isLoadingStatuses = true;
    });
    builder.addCase(getStatuses.fulfilled, (state, action) => {
      state.statuses = action.payload;
      state.isLoadingStatuses = false;
    });
    builder.addCase(getStatuses.rejected, (state) => {
      state.isLoadingStatuses = false;
    });

    builder.addCase(getGivenExchangesLabels.pending, (state) => {
      state.isLoadingGivenFilters = true;
    });
    builder.addCase(getGivenExchangesLabels.fulfilled, (state, action) => {
      state.givenFilters = action.payload;
      state.isLoadingGivenFilters = false;
    });
    builder.addCase(getGivenExchangesLabels.rejected, (state) => {
      state.isLoadingGivenFilters = false;
    });

    builder.addCase(getReceivedExchangesLabels.pending, (state) => {
      state.isLoadingReceivedFilters = true;
    });
    builder.addCase(getReceivedExchangesLabels.fulfilled, (state, action) => {
      state.receivedFilters = action.payload;
      state.isLoadingReceivedFilters = false;
    });
    builder.addCase(getReceivedExchangesLabels.rejected, (state) => {
      state.isLoadingReceivedFilters = false;
    });
  },
});

export const { setReceiveExchanges, clearExchangesState } = exchangesSlice.actions;

export default exchangesSlice.reducer;
